import React from "react";
import { useMantineTheme } from '@mantine/core';

import PickerDate from "../general/PickerDate";
import LabelWithAsterisk from "../general/LabelWithAsterisk";

const DateLinePengecekanDibatalkan = ({ stateData }) => {

    const theme = useMantineTheme();

    return (
        <React.Fragment>
            <PickerDate
                stateReadOnly={true}
                stateDate={stateData.data.value}
                stateVariant="default"
                stateClearable={false}

                stateStylesInput={{
                    backgroundColor: theme.colorScheme === 'light' ? '#fff' : theme.colors.dark[7]
                }}

                fnSetDate={() => { }}

                stateLabel={<LabelWithAsterisk stateLabel={stateData.data.label} />}
                statePlaceHolder={stateData.data.placeholder}
                stateWithAsterisk={false}
                stateDescription={stateData.data.description}
                stateError={stateData.data.error}
            />
        </React.Fragment>
    )
}

export default DateLinePengecekanDibatalkan;